import { Component } from 'react';
import { Card, Row, Col, Form, Button, Table, Badge, Modal, Spinner } from 'react-bootstrap';
import { FaPlus, FaSearch, FaEraser, FaEye } from 'react-icons/fa';
import { AppSelect, AppAsyncSelect } from '../../common/_components/AppSelect';
import Paginacao from '../../common/pagination';
import { formataDataHoraExibicao } from '../../common/utils';
import importacaoArquivosService from '../../api/suporte/importacaoArquivosService';
import ImportacaoArquivosModal from './ImportacaoArquivosModal';
import api from '../../services/api';

const AREAS_OPTIONS = [
    { value: '', label: 'Todas as áreas' },
    { value: 'pacientes', label: 'Pacientes' },
    { value: 'prestadores', label: 'Prestadores' },
    { value: 'agendamentos', label: 'Agendamentos' },
];

const STATUS_OPTIONS = [
    { value: '', label: 'Todos os status' },
    { value: 'validando', label: 'Validando' },
    { value: 'validado_ok', label: 'Validado OK' },
    { value: 'validado_com_erro', label: 'Validado com Erro' },
    { value: 'importando', label: 'Importando' },
    { value: 'importado_ok', label: 'Importado OK' },
    { value: 'importado_parcial', label: 'Importado Parcial' },
    { value: 'falha', label: 'Falha' },
    { value: 'cancelado', label: 'Cancelado' },
];

const STATUS_BADGE = {
    validado_ok: 'success',
    validado_com_erro: 'danger',
    importado_ok: 'success',
    importado_parcial: 'warning',
    importando: 'info',
    validando: 'info',
    falha: 'danger',
    cancelado: 'secondary',
};

const STATUS_LABEL = {
    validando: 'Validando',
    validado_ok: 'Validado com sucesso',
    validado_com_erro: 'Validado com erro',
    importando: 'Importando',
    importado_ok: 'Importado com sucesso',
    importado_parcial: 'Importado parcialmente',
    falha: 'Falha na importação',
    cancelado: 'Cancelado',
};

const AREA_LABEL = {
    pacientes: 'Pacientes',
    prestadores: 'Prestadores',
    agendamentos: 'Agendamentos',
};

class ImportacaoArquivos extends Component {
    constructor(props) {
        super(props);

        const hoje = new Date();
        const primeiroDiaMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1).toISOString().split('T')[0];
        const ultimoDiaMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0).toISOString().split('T')[0];

        this.state = {
            loading: true,
            error: '',
            listRegistros: {},
            page_numb: 1,
            limite: 30,

            filtro_programa_id: '',
            filtro_programa_nome: '',
            filtro_area: null,
            filtro_status: null,
            filtro_data_de: primeiroDiaMes,
            filtro_data_ate: ultimoDiaMes,
            filtro_nome_arquivo: '',
            filtro_somente_com_erro: false,

            showModalNova: false,
            showModalDetalhe: false,
            jobDetalhe: null,
            loadingDetalhe: false,
        };
    }

    componentDidMount() {
        this.consultarJobs(1);
    }

    consultarJobs = (page = 1) => {
        this.setState({ loading: true, error: '' });

        const params = { page, page_size: this.state.limite };
        if (this.state.filtro_programa_id) params.programa_id = this.state.filtro_programa_id;
        if (this.state.filtro_area) params.area = this.state.filtro_area;
        if (this.state.filtro_status) params.status = this.state.filtro_status;
        if (this.state.filtro_data_de) params.data_de = this.state.filtro_data_de;
        if (this.state.filtro_data_ate) params.data_ate = this.state.filtro_data_ate;
        if (this.state.filtro_nome_arquivo) params.nome_arquivo = this.state.filtro_nome_arquivo;
        if (this.state.filtro_somente_com_erro) params.somente_com_erro = 'true';

        importacaoArquivosService.listarJobs(params)
            .then(res => {
                this.setState({ loading: false, listRegistros: res.data, page_numb: page });
            })
            .catch(err => {
                const msg = err?.response?.status === 403
                    ? 'Você não tem permissão para acessar esta área.'
                    : 'Erro ao carregar o histórico de importações.';
                this.setState({ loading: false, error: msg });
            });
    };

    handleFiltrar = (e) => {
        e.preventDefault();
        this.consultarJobs(1);
    };

    handleLimparFiltro = () => {
        const hoje = new Date();
        const primeiroDiaMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1).toISOString().split('T')[0];
        const ultimoDiaMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0).toISOString().split('T')[0];

        this.setState({
            filtro_programa_id: '',
            filtro_programa_nome: '',
            filtro_area: null,
            filtro_status: null,
            filtro_data_de: primeiroDiaMes,
            filtro_data_ate: ultimoDiaMes,
            filtro_nome_arquivo: '',
            filtro_somente_com_erro: false,
        }, () => this.consultarJobs(1));
    };

    carregarProgramas = async (inputValue) => {
        try {
            const res = await api.get(`/programas/?nome=${inputValue}&limit=20`);
            return res.data.results.map(p => ({ value: p.id, label: p.nome }));
        } catch {
            return [];
        }
    };

    handleVerDetalhe = async (job) => {
        this.setState({ showModalDetalhe: true, jobDetalhe: null, loadingDetalhe: true });
        try {
            const res = await importacaoArquivosService.detalheJob(job.id);
            this.setState({ jobDetalhe: res.data, loadingDetalhe: false });
        } catch {
            this.setState({ loadingDetalhe: false });
        }
    };

    onClickPagina = (num_page) => {
        this.setState({ loading: true, page_numb: num_page });
        this.consultarJobs(num_page);
    };

    renderRows() {
        const results = this.state.listRegistros?.results || [];
        if (!results.length) {
            return (
                <tr>
                    <td colSpan={8} className="text-center text-muted py-4">
                        Nenhuma importação encontrada.
                    </td>
                </tr>
            );
        }
        return results.map(job => (
            <tr key={job.id}>
                <td>{job.id}</td>
                <td>{AREA_LABEL[job.area] || job.area}</td>
                <td title={job.nome_arquivo_original} style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {job.nome_arquivo_original}
                </td>
                <td>
                    <Badge bg={STATUS_BADGE[job.status] || 'secondary'}>
                        {STATUS_LABEL[job.status] || job.status}
                    </Badge>
                </td>
                <td className="text-center">{job.total_linhas}</td>
                <td className="text-center">
                    {job.erros > 0
                        ? <Badge bg="danger">{job.erros}</Badge>
                        : <span className="text-muted">0</span>}
                </td>
                <td>{job.created_at ? formataDataHoraExibicao(job.created_at) : '-'}</td>
                <td>
                    <Button
                        variant="light"
                        size="sm"
                        onClick={() => this.handleVerDetalhe(job)}
                    >
                        <FaEye /> Visualizar
                    </Button>
                </td>
            </tr>
        ));
    }

    render() {
        const {
            loading, error, listRegistros, page_numb, limite,
            showModalNova, showModalDetalhe, jobDetalhe, loadingDetalhe,
        } = this.state;

        return (
            <div>
                <Row className="align-items-center mb-3">
                    <Col sm={6}>
                        <h4 className="page-title">Importação de Arquivos</h4>
                    </Col>
                    <Col sm={6} className="text-end">
                        <Button variant="secondary" size="sm" onClick={() => this.setState({ showModalNova: true })}>
                            <FaPlus className="me-1" /> Adicionar nova importação
                        </Button>
                    </Col>
                </Row>

                <Card className="cardDestaque mb-3">
                    <Card.Body>
                        <h6>Filtros</h6>
                        <Form onSubmit={this.handleFiltrar}>
                            <Row>
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Programa</Form.Label>
                                        <AppAsyncSelect
                                            loadOptions={this.carregarProgramas}
                                            placeholder="Buscar programa..."
                                            value={this.state.filtro_programa_id
                                                ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome }
                                                : null}
                                            onChange={e => this.setState({
                                                filtro_programa_id: e?.value || '',
                                                filtro_programa_nome: e?.label || '',
                                            })}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Área</Form.Label>
                                        <AppSelect
                                            options={AREAS_OPTIONS}
                                            placeholder="Todas as áreas"
                                            value={AREAS_OPTIONS.find(a => a.value === (this.state.filtro_area || '')) || null}
                                            onChange={e => this.setState({ filtro_area: e?.value || null })}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Status</Form.Label>
                                        <AppSelect
                                            options={STATUS_OPTIONS}
                                            placeholder="Todos os status"
                                            value={STATUS_OPTIONS.find(s => s.value === (this.state.filtro_status || '')) || null}
                                            onChange={e => this.setState({ filtro_status: e?.value || null })}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data De</Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={this.state.filtro_data_de}
                                            onChange={e => this.setState({ filtro_data_de: e.target.value })}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data Até</Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={this.state.filtro_data_ate}
                                            onChange={e => this.setState({ filtro_data_ate: e.target.value })}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nome do arquivo</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Buscar por nome..."
                                            value={this.state.filtro_nome_arquivo}
                                            onChange={e => this.setState({ filtro_nome_arquivo: e.target.value })}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12} className="d-flex align-items-center pb-3">
                                    <Form.Check
                                        type="checkbox"
                                        label="Somente com erro"
                                        checked={this.state.filtro_somente_com_erro}
                                        onChange={e => this.setState({ filtro_somente_com_erro: e.target.checked })}
                                    />
                                </Col>
                            </Row>
                            <Button variant="secondary" type="submit" size="sm" disabled={loading}>
                                {loading ? <Spinner size="sm" /> : <FaSearch className="me-1" />} Filtrar
                            </Button>
                            <Button variant="light" size="sm" className="ms-2" onClick={this.handleLimparFiltro} disabled={loading}>
                                <FaEraser className="me-1" /> Limpar
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>

                {error && <div className="alert alert-danger">{error}</div>}

                {!error && (
                    <>
                        <Table responsive className="custom-table mt-3">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Área</th>
                                    <th>Arquivo</th>
                                    <th>Status</th>
                                    <th className="text-center">Linhas</th>
                                    <th className="text-center">Erros</th>
                                    <th>Data</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading
                                    ? <tr><td colSpan={8} className="text-center py-4"><Spinner /></td></tr>
                                    : this.renderRows()
                                }
                            </tbody>
                        </Table>

                        <Paginacao
                            dados={listRegistros}
                            limit={limite}
                            loading={loading}
                            page_numb={page_numb}
                            _onClickPagina={this.onClickPagina}
                        />
                    </>
                )}

                {/* Modal de nova importação */}
                <ImportacaoArquivosModal
                    show={showModalNova}
                    onHide={() => this.setState({ showModalNova: false })}
                    onJobConcluido={() => this.consultarJobs(1)}
                />

                {/* Modal de detalhe do job */}
                <Modal size="lg" show={showModalDetalhe} onHide={() => this.setState({ showModalDetalhe: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>Detalhe da Importação #{jobDetalhe?.id}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {loadingDetalhe && <div className="text-center py-3"><Spinner /></div>}
                        {jobDetalhe && !loadingDetalhe && (
                            <>
                                <Row className="mb-3">
                                    <Col sm={6}><strong>Área:</strong> {AREA_LABEL[jobDetalhe.area] || jobDetalhe.area}</Col>
                                    <Col sm={6}><strong>Status:</strong> <Badge bg={STATUS_BADGE[jobDetalhe.status] || 'secondary'}>{STATUS_LABEL[jobDetalhe.status] || jobDetalhe.status}</Badge></Col>
                                    <Col sm={6} className="mt-2"><strong>Arquivo:</strong> {jobDetalhe.nome_arquivo_original}</Col>
                                    <Col sm={6} className="mt-2"><strong>Data:</strong> {jobDetalhe.created_at ? formataDataHoraExibicao(jobDetalhe.created_at) : '-'}</Col>
                                    <Col sm={6} className="mt-2"><strong>Total linhas:</strong> {jobDetalhe.total_linhas}</Col>
                                    <Col sm={6} className="mt-2"><strong>Erros / Warnings:</strong> {jobDetalhe.erros} / {jobDetalhe.warnings}</Col>
                                </Row>
                                {jobDetalhe.mensagem_resumo && (
                                    <div className="alert alert-secondary">{jobDetalhe.mensagem_resumo}</div>
                                )}
                                {jobDetalhe.erros_detalhes?.length > 0 && (
                                    <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                                        <Table size="sm" bordered hover>
                                            <thead>
                                                <tr><th>Linha</th><th>Coluna</th><th>Sev.</th><th>Mensagem</th></tr>
                                            </thead>
                                            <tbody>
                                                {jobDetalhe.erros_detalhes.map((err, i) => (
                                                    <tr key={i} className={err.severidade === 'erro' ? 'table-danger' : 'table-warning'}>
                                                        <td>{err.linha ?? '-'}</td>
                                                        <td>{err.coluna || '-'}</td>
                                                        <td><Badge bg={err.severidade === 'erro' ? 'danger' : 'warning'}>{err.severidade}</Badge></td>
                                                        <td>{err.mensagem}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                )}
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-danger" onClick={() => this.setState({ showModalDetalhe: false })}>Fechar</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default ImportacaoArquivos;
